import { Outlet, useOutletContext } from "react-router";

import { WorkbenchContext } from "../types";

function Workbench(): React.JSX.Element {
  const context = useOutletContext<WorkbenchContext>();
  return <Outlet context={context} />;
}

export default Workbench;
